import _defineProperty from "/app/node_modules/.pnpm/next@13.4.17_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import useTracking from 'hooks/useTracking';
import { abTestExposeEvent } from 'libs/common/event-tracker/events';
import { getLocalStorageItem, setLocalStorageItem } from 'libs/utils/localStorage';
import { getAbTestByName } from 'state/ab-tests/selectors';
import { getExposee, getAnonId } from 'state/session/selectors';
const STORAGE_KEY_PREFIX = 'use-track-ab-test-expose-event-';

const useAbTest = _ref => {
  let {
    abTestName,
    shouldTrackExpose,
    shouldTrackOnce
  } = _ref;
  const abTest = useSelector(getAbTestByName(abTestName));
  const exposee = useSelector(getExposee);
  const annonId = useSelector(getAnonId);
  const {
    track
  } = useTracking();
  useEffect(() => {
    if (!shouldTrackExpose) return;
    if (!abTest) return;

    if (shouldTrackOnce) {
      const localStorageKey = "".concat(STORAGE_KEY_PREFIX).concat(abTestName);
      if (getLocalStorageItem(localStorageKey) === annonId) return;
      setLocalStorageItem(localStorageKey, annonId);
    }

    track(abTestExposeEvent(_objectSpread(_objectSpread({}, exposee), abTest)));
  }, [abTest, abTestName, annonId, exposee, shouldTrackExpose, shouldTrackOnce, track]);
  return abTest;
};

export default useAbTest;